import React from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../routes/routeName'
import StateComponents from '../../../components/state-component/StateComponents'
import TableCustom from '../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../utils/app.utils'
import { IconComponent } from '../../../assets/icons/iconComponent'
import ManageStateComplaintStatistics from './manageStateComplaintStatistics'
import HorizontalChart from './charts/HorizontalChart'
import { styled, Typography } from '@mui/material'
import LineChart from './charts/LineChart'
import PieChart from './charts/PieChart'
import { COMPLAINTS_STATUS_DATA } from '../../students/complaint/enum/complaint.enum'
import { useTranslation } from 'react-i18next'
import { languageEnum } from '../../../constants/enum'

type Props = {}

export const BoxChartsCustom = styled('div')(({ theme }) => ({
    display: "flex",
    flexDirection: 'column',
    width: '100%',
    boxShadow: "2px 3px 4px rgba(0,0,0,0.4)",
    borderRadius: "20px",
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
    }
}))

const ComplaintStatistics: React.FC<Props> = (props: Props) => {
    const { t, i18n } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        date_range,
        handleChangeDateRange,
        setSearch,
        complaint_type_data,
        id_complaints_type,
        set_id_complaints_type,
        set_search_complaint_type,
        // handleDownloadReport,
        complaints_charts_status,
        complaints_charts_type,
        status,
        set_status
    } = ManageStateComplaintStatistics()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("COMPLAINTS_STATISTICS")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("COMPLAINTS_COMPLAINT_SYSTEM"),
                                disabled_match: true,
                                pathName: "",
                            },
                            {
                                key: "complaintSubmit",
                                name: t("COMPLAINTS_STATISTICS"),
                                pathName: routeName.cms.complaintsStatistics
                            },
                        ]}
                    />
                }
                // buttonContent={
                //     <ContainerButton
                //         justifyContent='flex-end'
                //         buttonData={[
                //             {
                //                 buttonProps: {
                //                     onClick: handleDownloadReport
                //                 },
                //                 key: "DOWNLOAD_CSV",
                //                 label: "ดาวน์โหลด CSV",
                //                 seq: 1,
                //                 type: "DOWNLOAD_CSV"
                //             }
                //         ]}
                //     />
                // }
                content={
                    <div className='w-full'>
                        <div className='w-full flex flex-col md:flex-row gap-4 my-10'>
                            <BoxChartsCustom>
                                <span className='w-full bg-[#4A4A4A] text-white text-xl h-[60px] flex justify-start px-4 items-center rounded-t-[20px]'>
                                    {t("COMPLAINTS_COMPLAINT_STATISTICS_BY_CATEGORY")}
                                </span>
                                <span className='w-full px-6 py-10'>
                                    <HorizontalChart
                                        categories={complaints_charts_type.name || []}
                                        data={complaints_charts_type.val || []}
                                    />
                                </span>
                            </BoxChartsCustom>
                            <BoxChartsCustom>
                                <span className='w-full bg-[#4A4A4A] text-white text-xl h-[60px] flex justify-start px-4 items-center rounded-t-[20px]'>
                                    {t("COMPLAINTS_COMPLAINT_STATISTICS_BY_STATUS")}
                                </span>
                                <span className='my-10'>
                                    <PieChart
                                        data={complaints_charts_status || []}
                                    />
                                </span>
                            </BoxChartsCustom>
                        </div>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        placeholder: t("COMPLAINTS_SEARCH_CATEGORY_CREATOR_UPDATED"),
                                        startAdornment: <IconComponent.SearchIcon />,
                                        onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        getOptionLabel: (op) => op?.complaints_type_name || "",
                                        labelId: "id_complaints_type",
                                        onChange: (_: unknown, val: any) => set_id_complaints_type(val),
                                        onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_complaint_type }),
                                        placeholder: t("COMPLAINTS_ALL_CATEGORIES"),
                                        options: complaint_type_data || [],
                                        value: id_complaints_type
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        allowClear: true,
                                        en: i18n.language === languageEnum.EN,
                                        onClear: () => handleChangeDateRange([]),
                                        placeholder: t("COMPLAINTS_DATE_RANGE"),
                                        value: date_range

                                    }
                                },
                                {
                                    seq: 4,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        getOptionLabel: (op) => op?.label || "",
                                        labelId: "STATUS",
                                        onChange: (_, val) => set_status(val?.value),
                                        placeholder: t("COMPLAINTS_ALL_STATUSES"),
                                        options: COMPLAINTS_STATUS_DATA,
                                        value: COMPLAINTS_STATUS_DATA.find((x) => x.value === status) || null
                                    }
                                },
                            ]}
                        />

                        <div className='mt-10'>
                            <section className='w-full mt-10'>
                                <TableCustom
                                    tableMinWidth={1920}
                                    tableFixedWidth
                                    customScroll
                                    page={page}
                                    pageLimit={pageLimit}
                                    sortBy={sortBy}
                                    sortType={sortType}
                                    headCells={headCells}
                                    rowCount={totalItems}
                                    rowsData={data?.map((data: any, i: any) => {
                                        return renderData(data, i)
                                    })}
                                    onSort={handleRequestSort}
                                    setPageLimit={(value: number) => setPageLimit(value)}
                                    setPage={(value: number) => setPage(value)}
                                />
                            </section>
                        </div>
                    </div>
                }
            />
        </div>
    )
}

export default ComplaintStatistics